import { render, staticRenderFns } from "./mes-bom-form.vue?vue&type=template&id=6a0b85ba&"
import script from "./mes-bom-form.vue?vue&type=script&lang=js&"
export * from "./mes-bom-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports